import {WizardComponentController} from "../WizardComponent";

export const WizardFooter = "tfWizardFooter";

export function wizardFooter() {
    return {
        template,
        transclude: true,
        require: {
            wizard: "^^tfWizard"
        },
        controllerAs: "ctrl",
        controller: WizardFooterController
    };
}

export class WizardFooterController {
    public wizard: WizardComponentController;
}

const template = `
    <ng-transclude></ng-transclude>
`;
